import { fetchConfig } from '@theme/utilities';
import { CartAddEvent } from '@theme/events';

/**
 * Inline size quick-add on product cards — selecting a size adds that variant
 * and refreshes the cart drawer (including Complete the kit).
 */

/**
 * @returns {string}
 */
function getCartSectionIds() {
  return [
    ...new Set(
      Array.from(document.querySelectorAll('cart-items-component'))
        .map((el) => (el instanceof HTMLElement ? el.dataset.sectionId : null))
        .filter(Boolean)
    ),
  ].join(',');
}

/**
 * @param {object} data
 * @param {string} variantId
 * @param {string} [productId]
 */
function dispatchCartAdd(data, variantId, productId) {
  document.dispatchEvent(
    new CartAddEvent(data, 'dm-inline-size-quick-add', {
      source: 'dm-inline-size-quick-add',
      productId: productId ? String(productId) : undefined,
      variantId: String(variantId),
      itemCount: Array.isArray(data.items) ? data.item_count || data.items.length : data.item_count,
      sections: data.sections || {},
    })
  );
}

/**
 * @param {string} variantId
 * @param {string} [productId]
 */
async function addVariantToCart(variantId, productId) {
  const sections = getCartSectionIds();
  const cartAddUrl = Theme.routes.cart_add_url;

  const response = await fetch(
    cartAddUrl,
    fetchConfig('json', {
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections,
        sections_url: window.location.pathname,
      }),
    })
  );

  const data = await response.json();
  if (!response.ok || data.status || data.message || data.errors) {
    const message = data.description || data.message || data.errors || 'Add failed';
    throw new Error(typeof message === 'string' ? message : 'Add failed');
  }

  dispatchCartAdd(data, variantId, productId);

  const drawer = document.querySelector('cart-drawer-component');
  if (drawer && typeof drawer.open === 'function') {
    drawer.open();
  }
}

document.addEventListener('click', async (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const pill = target.closest('.dm-inline-size__pill');
  if (!(pill instanceof HTMLElement) || pill.disabled) return;

  const root = pill.closest('.dm-inline-size');
  if (!(root instanceof HTMLElement)) return;

  event.preventDefault();
  event.stopPropagation();

  const variantId = pill.dataset.variantId;
  if (!variantId) return;

  root.querySelectorAll('.dm-inline-size__pill').forEach((el) => el.classList.remove('is-selected'));
  pill.classList.add('is-selected');

  const variantInput = root.querySelector('[data-inline-size-variant], [ref="variantId"]');
  if (variantInput instanceof HTMLInputElement) {
    variantInput.value = variantId;
  }

  try {
    pill.disabled = true;
    await addVariantToCart(variantId, root.dataset.productId);
  } catch (err) {
    console.error('[dm-inline-size]', err);
    const cardLink = pill.closest('product-card')?.querySelector('a[href*="/products/"]');
    const fallbackUrl = cardLink?.getAttribute('href') || '/';
    window.location.href = fallbackUrl;
  } finally {
    pill.disabled = false;
  }
});
